export default {
    namespaced: true,

    state: {
        knownAwards: {}
    },

    mutations: {
        registerAward: function (state, award) {
            state.knownAwards[award.url] = award
        }
    }
}



// WEBPACK FOOTER //
// ./sv_cms/static/assets/vue/components/visualization/history/store.js